import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { idbStore } from "./store";
import { Wallet, type IdentityRecord } from "./wallet";

interface Ctx { wallet: Wallet; identity?: IdentityRecord; ready: boolean; refresh: () => Promise<void> }
const WalletCtx = createContext<Ctx | null>(null);

export function WalletProvider({ children }: { children: ReactNode }) {
  const wallet = useMemo(() => new Wallet(idbStore()), []);
  const [identity, setIdentity] = useState<IdentityRecord | undefined>();
  const [ready, setReady] = useState(false);
  const refresh = async () => { setIdentity(wallet.record ? { ...wallet.record } : await wallet.load()); };
  useEffect(() => { wallet.load().then((r) => { setIdentity(r); setReady(true); }); }, [wallet]);
  return <WalletCtx.Provider value={{ wallet, identity, ready, refresh }}>{children}</WalletCtx.Provider>;
}

export function useWallet(): Ctx {
  const c = useContext(WalletCtx);
  if (!c) throw new Error("useWallet outside WalletProvider");
  return c;
}
